import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { moveCartCopy } from "../utils/branchAvailability";

/**
 * "Move your cart to <branch>?" A cart is fulfilled from ONE location: every
 * line carries the same outletId, so the server can refuse a mixed basket.
 * When a shopper with items from one location adds from another (a deep link
 * to a product on another branch, a branch's menu opened from a link) this
 * asks first, and on a yes the cart MOVES to the new location instead of
 * being cleared.
 *
 * A branch can now have its own sold out, on/off and price (4 Oct 2026), so
 * the copy no longer promises the same prices: every item is checked at the
 * new branch and anything that changed is shown before the shopper pays
 * (hooks/useBranchCartCheck). Same words as the apps and the location
 * picker (utils/branchAvailability.moveCartCopy).
 *
 * The main store (no outlet) counts as a location here too. `brandName` is
 * accepted for older callers and no longer shown.
 */
const OutletSwitchDialog = ({ open, fromLabel, toLabel, onCancel, onConfirm }) => {
  const copy = moveCartCopy({ to: toLabel, from: fromLabel });
  return (
    <Dialog
      open={Boolean(open)}
      onClose={onCancel}
      aria-labelledby="outlet-switch-dialog-title"
      aria-describedby="outlet-switch-dialog-description"
    >
      <DialogTitle id="outlet-switch-dialog-title">{copy.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="outlet-switch-dialog-description">
          {copy.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          {copy.stayLabel}
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained" autoFocus>
          {copy.moveLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OutletSwitchDialog;
